module.exports = __webpack_public_path__ + "static/media/figma.8e60c911.svg";